import http from './httpService';
import config from '../configs/config.js';

const url = config.chatEndPoint + '/qa';

// 1. Get Summary
export async function getAnswer(question) {
  let answer = await http.post(
    url,
    {
      query: question
    },
    { withCredentials: false }
  );
  return answer;
}
